import React from 'react';

const C = {
  bg: '#fbfaf6',
  ink: '#1a2a26',
  inkMuted: '#5a6b65',
  inkFaint: '#8b9690',
  line: '#e8e2d4',
  accent: '#2d6e58',
};

const TermsPage: React.FC = () => (
  <div style={{ background: C.bg, minHeight: '100vh', fontFamily: 'system-ui, sans-serif', color: C.ink }}>
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '48px 24px' }}>
      <a href="/" style={{ color: C.accent, textDecoration: 'none', fontSize: 14 }}>← Back to Nice Agenda</a>
      <h1 style={{ marginTop: 32, marginBottom: 8, fontSize: 32, fontWeight: 700 }}>Terms of Service</h1>
      <p style={{ color: C.inkFaint, fontSize: 14, marginBottom: 40 }}>Effective date: May 1, 2026</p>

      <Section title="1. Acceptance of Terms">
        By accessing or using Nice Agenda ("the Service"), operated by PEDRO BAJOTTO FILHO LTDA,
        you agree to be bound by these Terms of Service.
        If you do not agree to these terms, please do not use the Service.
      </Section>

      <Section title="2. Description of Service">
        Nice Agenda is a calendar and appointment management platform designed for clinics and medical practices.
        The Service includes scheduling, client management, WhatsApp reminders, and related features offered
        under Free and Pro subscription plans.
      </Section>

      <Section title="3. Accounts">
        You must provide accurate information when creating an account. You are responsible for maintaining
        the confidentiality of your credentials and for all activity that occurs under your account.
        You must notify us immediately of any unauthorized use.
      </Section>

      <Section title="4. Subscription and Billing">
        Pro plan subscriptions are billed through Paddle, our authorized reseller and merchant of record.
        Paddle handles all payment processing, invoicing, and applicable taxes on our behalf.
        By subscribing you also agree to Paddle's terms and conditions available at paddle.com.
        Subscription fees are charged at the start of each billing period and are non-refundable
        except as described in our Refund Policy.
      </Section>

      <Section title="5. Acceptable Use">
        You agree not to misuse the Service. Prohibited conduct includes, but is not limited to:
        using the Service for unlawful purposes; attempting to gain unauthorized access to any part of the
        Service; transmitting malware or harmful code; violating the privacy of others; or reselling
        access to the Service without written permission.
      </Section>

      <Section title="6. Data and Privacy">
        Your use of the Service is also governed by our Privacy Policy, which is incorporated into
        these Terms by reference. You are responsible for ensuring that any personal data you input
        about your clients complies with applicable data protection laws.
      </Section>

      <Section title="7. Intellectual Property">
        All content, trademarks, and software comprising the Service are owned by or licensed to
        Nice Agenda. You may not copy, modify, distribute, or create derivative works without
        our prior written consent.
      </Section>

      <Section title="8. Limitation of Liability">
        To the maximum extent permitted by law, Nice Agenda shall not be liable for any indirect,
        incidental, special, or consequential damages arising from your use of the Service,
        even if we have been advised of the possibility of such damages.
        Our total liability shall not exceed the amount you paid us in the 12 months preceding the claim.
      </Section>

      <Section title="9. Termination">
        We reserve the right to suspend or terminate your account for violation of these Terms.
        You may cancel your subscription at any time through your account settings.
        Upon termination, your right to use the Service ceases immediately.
      </Section>

      <Section title="10. Changes to Terms">
        We may update these Terms from time to time. We will notify you of material changes by email
        or through the Service. Continued use after changes take effect constitutes your acceptance
        of the revised Terms.
      </Section>

      <Section title="11. Contact">
        For questions about these Terms, please contact us at{' '}
        <a href="mailto:pedro@bajotto.com" style={{ color: C.accent }}>pedro@bajotto.com</a>.
      </Section>
    </div>
  </div>
);

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div style={{ marginBottom: 32 }}>
    <h2 style={{ fontSize: 18, fontWeight: 600, color: C.ink, marginBottom: 8 }}>{title}</h2>
    <div style={{ borderTop: `1px solid ${C.line}`, paddingTop: 12 }}>
      <p style={{ color: C.inkMuted, lineHeight: 1.7, margin: 0, fontSize: 15 }}>{children}</p>
    </div>
  </div>
);

export default TermsPage;
